import { JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowRight, FaBan, FaCheck } from 'react-icons/fa6';
import { Plus } from '../../components/plus';
import { PartnerShipStatus } from '../../dto/partnership';
import { useLayout } from '../../hooks/layout.hook';
import { useNavigation } from '../../hooks/navigation.hook';
import { usePartnership } from '../../hooks/partnership.hook';

export default function PartnerScreen(): JSX.Element {
  const { navigate } = useNavigation();
  const { t } = useTranslation();
  const { partnershipsLoading, partnerships, acceptPartnership, rejectPartnership, deletePartnership } =
    usePartnership();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useLayout(
    () => ({ activeMenu: 'partners', title: t('Partners'), loading: partnershipsLoading }),
    [t, partnershipsLoading],
  );

  return (
    <>
      {partnerships.length ? (
        <ul className="list bg-base-100 rounded-box shadow-md">
          {partnerships.map((p) => {
            const canEnd = [PartnerShipStatus.REJECTED, PartnerShipStatus.ENDED].includes(p.status);
            const canOpen = !canEnd && p.status !== PartnerShipStatus.PENDING;

            return (
              <li
                key={p.id}
                className={`list-row flex items-center ${
                  canOpen && 'cursor-pointer transition duration-200 hover:bg-base-300 active:bg-base-200'
                }`}
                onClick={() =>
                  canOpen ? navigate('/partners/details', { replace: false, state: p }) : canEnd && deletePartnership(p)
                }
              >
                <div className="flex-grow-1">
                  <div className="font-bold line-clamp-1 text-lg">{p.partner.name}</div>
                  <div className="text-base-content/70 line-clamp-1">{p.partner.mail}</div>
                </div>

                <div className="flex flex-col justify-center whitespace-nowrap">
                  {p.status === PartnerShipStatus.PENDING ? (
                    p.isMyRequest ? (
                      <button className="btn btn-disabled btn-sm">{t('Pending')}</button>
                    ) : (
                      <div className="join">
                        <button className="join-item btn btn-success btn-lg" onClick={() => acceptPartnership(p)}>
                          <FaCheck size={'1.2rem'} />
                        </button>
                        <button className="join-item btn btn-error btn-lg" onClick={() => rejectPartnership(p)}>
                          <FaBan size={'1.2rem'} />
                        </button>
                      </div>
                    )
                  ) : p.status === PartnerShipStatus.REJECTED ? (
                    <button className="btn btn-disabled btn-sm">{t('Rejected')}</button>
                  ) : (
                    p.status === PartnerShipStatus.ENDED && (
                      <button className="btn btn-disabled btn-sm">{t('Ended')}</button>
                    )
                  )}
                </div>

                {canOpen && (
                  <div>
                    <FaArrowRight size={'1.2rem'} />
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="text-center text-base-content/70">
          {t("Add a partner to grow faster in your virtues! Partners can view each other's statistics.")}
        </div>
      )}

      <Plus className="mt-5" onClick={() => navigate('/partners/add')} />
    </>
  );
}
